import Glide from '@glidejs/glide';

// Glider
new Glide('#testimonial-slide', {
  type: 'slider',
  perView: 1,
  dragDistance: true,
  dragThreshold: true,
}).mount();

// Animation activate
const sectionAnimation = () => {
  const sections = document.querySelectorAll('[data-animate]');  
  
  sections.forEach(section => {
    const halfWindow = window.innerHeight * 0.6;
    const isSectionVisible = (section.getBoundingClientRect().top - halfWindow) < 0;

    if(isSectionVisible) {
      section.setAttribute("data-animate", "true");
    }
  });  
}

window.addEventListener('scroll', sectionAnimation);

